<div #toolbar>
  <div class="flex flex-row flex-wrap items-center justify-center w-full">
    <span
      class="text-secondary w-fit text-lg cursor-pointer"
      (click)="navigateToPathPart(-1)"
      >{{ pathDescription() }}/</span
    >
    @for (pathPart of splittedPathParts(); track $index; let i = $index) {
      <span class="w-fit cursor-pointer" (click)="navigateToPathPart(i)">
        {{ pathPart }}/
      </span>
    }
  </div>
  <div class="flex flex-row items-center justify-center gap-2">
    @if (compactTreeView() || isLessThan900()) {
      <button mat-icon-button (click)="showFileTreePanel()">
        <mat-icon>account_tree</mat-icon>
      </button>
    }
    <sia-search-box
      class="flex-grow"
      (searchExpChange)="manageResearch($event)"
      (searchClicked)="manageResearch($event)"
    ></sia-search-box>
  </div>
</div>

<div
  class="relative pt-2"
  [class]="
    (fileTreePanelVisible() && compactTreeView()) || isLessThan900()
      ? ''
      : 'flex flex-row gap-2'
  "
  [style]="
    'height: calc(100% - ' +
    (toolbar.offsetHeight + bottomActions.offsetHeight) +
    'px)'
  "
>
  @if (showFileTree() && (isLessThan900() || compactTreeView())) {
    <div
      class="file-tree surface absolute inset-x-0 inset-y-2 z-10 translate-x-[110%] overflow-auto rounded-xl shadow-lg transition-transform duration-300"
      [class]="fileTreePanelVisible() ? '!translate-x-0' : ''"
    >
      <ng-container [ngTemplateOutlet]="sidePanel"> </ng-container>
    </div>
  }
  @if (showFileTree() && !compactTreeView() && !isLessThan900()) {
    <div
      class="surface h-full w-[400px] overflow-auto rounded-xl"
      [class]="fileTreePanelVisible() ? '!translate-x-0' : ''"
    >
      <ng-container [ngTemplateOutlet]="sidePanel"></ng-container>
    </div>
  }
  @if (dropVisible()) {
    <ngx-file-drop
      (onFileDrop)="dropped($event)"
      [multiple]="true"
      dropZoneClassName="w-full h-full surface-low rounded-xl border-dashed border-2"
      contentClassName="h-full w-full flex justify-center items-center relative"
      class="w-full h-full"
    >
      <ng-template
        ngx-file-drop-content-tmp
        let-openFileSelector="openFileSelector"
      >
        <div
          class="flex flex-col items-center justify-center w-full h-full p-4"
        >
          <button
            mat-icon-button
            (click)="dropVisible.set(false)"
            class="!absolute right-2 top-2"
          >
            <mat-icon>close</mat-icon>
          </button>
          <div class="flex flex-col items-center justify-center flex-grow">
            <button
              mat-stroked-button
              type="button"
              (click)="openFileSelector()"
            >
              {{ 'Esplora file' | siaTranslate }}
            </button>
          </div>
          @if (activeUploads().length > 0) {
            <div class="flex max-h-[150px] w-full flex-col gap-2 overflow-auto">
              @for (upload of activeUploads(); track upload.id) {
                <div class="flex flex-col w-full gap-1">
                  <div class="flex items-center justify-between text-xs">
                    <span class="truncate">{{ upload.name }}</span>
                    <span>{{ upload.progress }}%</span>
                  </div>
                  <mat-progress-bar
                    mode="determinate"
                    [value]="upload.progress"
                  ></mat-progress-bar>
                </div>
              }
            </div>
          }
        </div>
      </ng-template>
    </ngx-file-drop>
  }
  @if (path() && !dropVisible()) {
    <div
      class="file-container h-full overflow-auto"
      [class]="
        showFileTree() && !compactTreeView() && !isLessThan900()
          ? 'w-[calc(100%-400px-.5rem)]'
          : 'w-full'
      "
    >
      <div
        style="visibility: hidden; position: fixed"
        #menuTriggerReference="matMenuTrigger"
        [style.left.px]="menuX()"
        [style.top.px]="menuY()"
        [matMenuTriggerFor]="rootMenu"
      ></div>
      <div class="flex flex-row flex-wrap gap-2">
        @for (file of fileElements(); track file) {
          <div
            class="surface-low file-item flex flex-row items-center justify-between w-full gap-2 px-2 py-1 rounded-lg"
            [attr.pathname]="file.id"
            (click)="navigate(file)"
            (dblclick)="openPreview(file)"
          >
            <div class="flex w-[calc(100%-43px)] flex-row items-center gap-2">
              <div
                class="flex w-[40px] cursor-pointer justify-center"
                (click)="!file.isFolder ? openPreview(file) : null"
              >
                @if (file.isFolder) {
                  <mat-icon class="fill text-orange-200"> folder </mat-icon>
                } @else if (!file.hasPreview) {
                  @let docIcon = getDocumentIcon(file.name, file.extension);
                  <mat-icon [style.color]="docIcon.color">
                    {{ docIcon.icon }}
                  </mat-icon>
                } @else {
                  <img #previewImage [src]="file.previewUrl" width="40" />
                }
              </div>

              <div class="flex w-[calc(100%-40px)] flex-col gap-1">
                <div class="w-full font-semibold truncate">
                  {{ getElementFullName(file) }}
                </div>
                @if (file.isFolder) {
                  <span>
                    {{
                      !file.childCount
                        ? '0 Elementi'
                        : file.childCount == 1
                          ? '1 Elemento'
                          : file.childCount + ' Elementi'
                    }}
                  </span>
                }
                @if (file.lastWriteTime || file.size) {
                  <div class="w-full text-xs truncate">
                    <span>
                      {{
                        file.lastWriteTime
                          ? (file.lastWriteTime | date: 'dd/MM/yy HH:mm')
                          : ''
                      }}
                    </span>
                    @if (file.size && !file.isFolder && file.lastWriteTime) {
                      <span> &nbsp; - &nbsp; </span>
                    }
                    @if (file.size && !file.isFolder) {
                      <span>
                        {{ file.size ? (file.size | convertBytes) : '' }}
                      </span>
                    }
                  </div>
                }
              </div>
            </div>
            <button
              mat-icon-button
              (click)="preventDefault($event)"
              [matMenuTriggerFor]="rootMenu"
              [matMenuTriggerData]="{ element: file }"
              #menuTrigger="matMenuTrigger"
            >
              <mat-icon> more_vert </mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  }
</div>
<div #bottomActions class="pt-2">
  @if (!dropVisible()) {
    <button mat-flat-button class="w-full" [matMenuTriggerFor]="uploadMenu">
      <mat-icon>add</mat-icon>
      <span>{{ 'Aggiungi' | siaTranslate }}</span>
    </button>
  }
</div>
@if (previewFileId()) {
  <div class="preview-overlay" (click)="closePreview()">
    <div
      class="preview-overlay-content surface"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-center justify-between gap-2 p-2">
        <span class="px-2 font-semibold truncate">{{ previewFileName() }}</span>
        <button mat-icon-button (click)="closePreview()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="preview-overlay-body">
        <sia-file-preview-handler
          [fileId]="previewFileId()!"
          [fileType]="previewFileType()"
          [fileName]="previewFileName()"
          [showFullscreen]="false"
        ></sia-file-preview-handler>
      </div>
    </div>
  </div>
}

<mat-menu #rootMenu="matMenu" [overlapTrigger]="false">
  <ng-template matMenuContent let-element="element">
    @if (
      foldersExist(element) ||
      (path()?.parentPath && path()?.parentPath?.enableActions)
    ) {
      <button
        mat-menu-item
        [matMenuTriggerFor]="moveToMenu"
        [matMenuTriggerData]="{ self: element }"
      >
        <mat-icon>open_with</mat-icon>
        <span>{{ 'Muovi' | siaTranslate }}</span>
      </button>
    }
    <button mat-menu-item (click)="openRenameDialog(element)">
      <mat-icon>edit</mat-icon>
      <span>{{ 'Rinomina' | siaTranslate }}</span>
    </button>
    @if (!element.isFolder) {
      @if (element.enableEdit) {
        <button mat-menu-item (click)="modifyFile(element)">
          <mat-icon>edit_document</mat-icon>
          <span>{{ 'Modifica' | siaTranslate }}</span>
        </button>
      }
      <button mat-menu-item (click)="download(element)">
        <mat-icon>download</mat-icon>
        <span>{{ 'Scarica' | siaTranslate }}</span>
      </button>
    }
    <button mat-menu-item (click)="deleteElement(element)">
      <mat-icon>delete</mat-icon>
      <span>{{ 'Elimina' | siaTranslate }}</span>
    </button>
  </ng-template>
</mat-menu>

<mat-menu #uploadMenu="matMenu" [overlapTrigger]="false">
  <ng-template matMenuContent>
    <button mat-menu-item (click)="onPasteClick()">
      <mat-icon>content_paste</mat-icon>
      <span>{{ 'Incolla da clipboard' | siaTranslate }}</span>
    </button>
    <button mat-menu-item (click)="createFolder()">
      <mat-icon>create_new_folder</mat-icon>
      <span>{{ 'Crea cartella' | siaTranslate }}</span>
    </button>
    <button mat-menu-item (click)="enableFileDrop()">
      <mat-icon>edit</mat-icon>
      <span>{{ 'Carica File' | siaTranslate }}</span>
    </button>
  </ng-template>
</mat-menu>

<mat-menu #moveToMenu="matMenu">
  <ng-template matMenuContent let-self="self">
    @if (path()?.parentPath && path()?.parentPath?.enableActions) {
      <button mat-menu-item (click)="moveElementToParent(self)">
        <mat-icon>drive_folder_upload</mat-icon>
        {{ 'Sopra' | siaTranslate }}
      </button>
    }
    @for (element of fileElements(); track element) {
      @if (element.isFolder && element.id !== self.id) {
        <button mat-menu-item (click)="moveElement(self, element)">
          {{ getElementFullName(element) }}
        </button>
      }
    }
  </ng-template>
</mat-menu>

<ng-template #sidePanel>
  <div class="flex justify-end p-1" #closeTreeButton>
    @if (!(showFileTree() && !compactTreeView() && !isLessThan900())) {
      <button mat-icon-button (click)="fileTreePanelVisible.set(false)">
        <mat-icon> close </mat-icon>
      </button>
    }
  </div>
  <div
    [style]="
      'height: calc(100% - ' +
      closeTreeButton.offsetHeight +
      'px); overflow: auto; width: 100%'
    "
  >
    <mat-tree
      [dataSource]="fileTree"
      [treeControl]="treeControl"
      style="background: unset"
    >
      <mat-tree-node
        *matTreeNodeDef="let node"
        matTreeNodePadding
        [matTreeNodePaddingIndent]="12"
        [class]="node.selected ? 'bg-primary-container' : ''"
        (click)="navigateTreeElement(node)"
      >
        <button mat-icon-button [attr.aria-label]="'Toggle ' + node.name">
          <mat-icon class="mat-icon-rtl-mirror"> </mat-icon>
        </button>
        @if (node.isFolder) {
          <mat-icon class="fill text-orange-200"> folder </mat-icon>
        }
        @if (!node.isFolder) {
          <mat-icon> description </mat-icon>
        }
        <span>{{ node.name }}</span>
      </mat-tree-node>
      <mat-tree-node
        *matTreeNodeDef="let node; when: hasChild"
        matTreeNodePadding
        [matTreeNodePaddingIndent]="12"
        [class]="node.selected ? 'bg-primary-container' : ''"
        (click)="navigateTreeElement(node)"
      >
        <button
          mat-icon-button
          matTreeNodeToggle
          [attr.aria-label]="'Toggle ' + node.name"
        >
          <mat-icon class="mat-icon-rtl-mirror">
            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
        </button>
        @if (node.isFolder) {
          <mat-icon class="fill text-orange-200"> folder </mat-icon>
        } @else {
          <mat-icon> description </mat-icon>
        }
        <span>{{ node.name }}</span>
      </mat-tree-node>
    </mat-tree>
  </div></ng-template
>
